import React from "react";
import type { ReactNode } from "react";

import styles from "./BodyFrame.module.scss";

interface Props {
  children: ReactNode,
  className?: string,
}

export function BodyFrame({ children, className }: Props) {
  return (
    <div className={`${styles.BodyFrame} ${className}`}>
      {children}
    </div>
  )
}

